<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a><a id="piv"></a>
<p class="left ">Copyright © 1967 by Arnoldo Mondadori Editore–Milano</p>
<p class="left ">English translation copyright © 1967 by Harcourt, Inc.</p>
<p class="left ">Copyright renewed 1995 by Harcourt, Inc.</p>
<p class="left spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="left spaceabove1">
<a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a>
</p>
<p class="left spaceabove1">Originally published in Italy: in Russian, as <em>Krutoj Mars rut;</em> in Italian, as <em>Viaggio nella Vertigine.</em></p>
<p class="left spaceabove1">The Library of Congress has cataloged the print edition as follows:</p>
<p class="left ">Ginzburg, Evgenia Semenovna.<br/>
Journey into the whirlwind.<br/>
“A Helen and Kurt Wolff book.”<br/>
Translation of Kruto marshrut.</p>
<p class="left ">1. Political prisoners—Russia—Personal narratives. 2. Russia—Social conditions—1917— I. Title.</p>
<p class="left ">[DK268.3.G513 1975] 365'6'0924[B] 74-16406</p>
<p class="left "><span class="smallcaps">ISBN</span> 0-15-602751-8 (Harvest: pbk.)</p>
<p class="left spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-54101-3<br/>
v3.1020</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?1ac964a3